"use strict"
import React, { useContext, useMemo } from 'react'
import { AuthContext, EventsContext, LanguageContext, NewsContext, StatisticsContext } from '../context'
import YouTube from "react-youtube";
import NewsCarouselContinuous from '../components/NewsCarouselContinuous';

const PRESS_CATEGORY_ID = 'daPO5ywdBkdfpJW1N3tr'

const HomePage = () => {

  const { authStateLoaded, userDataLoaded, isUserAuthenticated } = useContext(AuthContext)
  const { promptCreateEvent } = useContext(EventsContext)
  const { t, currentLocale, localizedProperty } = useContext(LanguageContext)
  const { news = [], newsLoaded } = useContext(NewsContext)
  const { statistics, statisticsLoaded } = useContext(StatisticsContext)
  
  const showLoading = !authStateLoaded || (isUserAuthenticated && !userDataLoaded)
  

  const filteredNews = useMemo(() => {
    return news.filter((newsItem) => {
      if (!newsItem.categories?.includes(PRESS_CATEGORY_ID)) {
        return false
      }
      if (newsItem.locales && newsItem.locales.length > 0) {
        return newsItem.locales.includes(currentLocale)
      }
      return true
    })
  }, [news, currentLocale])

  // Home page video 

  const videoPlayerOptions = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 1,
      controls: 1,
    }
  }

  const _onVideoPlayerReady = (event) => {
    event.target.pauseVideo();
  }

  const videoLocales = ['fr-FR']
  const isVideoAvailable = videoLocales.includes(currentLocale)

  // Stats formatting 

  const printNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  return (
    <div className='mx-4'>
      {showLoading && <div className='global-loading'>
        <div className='global-loading__background' />
        <div className='global-loading__spinner' />
      </div>}

      <h1 className='big-title mb-10 mt-20 lg:mt-32'>
        {t('home.title')}
      </h1>
      <p className='home-page-text mx-auto mb-20'>
        <b>WeCar </b>{t('home.subtitle')}
      </p>
      {/* <img src="/calendars.jpg" className='mx-auto mb-20'/> */}
      <div className='grid lg:grid-cols-3 gap-16 max-w-5xl mx-auto mb-20'>
        <div className='max-w-64 mx-auto'>
          <div className='img-parent mb-9 mx-auto w-36'>
            <img src='1.svg' className='w-full' />
          </div>
          <h3 className='home-title'>{t('home.create_title')}</h3>
          <p className='home-text'>
            {t('home.create_text')}
          </p>
        </div>
        <div className='max-w-64 mx-auto'>
          <div className='img-parent mb-8 mx-auto w-32'>
            <img src='2.svg' className='w-full' />
          </div>
          <h3 className='home-title'>{t('home.share_title')}</h3>
          <p className='home-text'>
            {t('home.share_text')}
          </p>
        </div>
        <div className='max-w-64 mx-auto'>
          <div className='img-parent mb-4 mx-auto w-32'>
            <img src='3.svg' className='w-full' />
          </div>
          <h3 className='home-title'>{t('home.organise_title')}</h3>
          <p className='home-text'>
            {t('home.organise_text')}
          </p>
        </div>
      </div>
      <div className='mb-10'>
        <button className='mx-auto big max-w-96 w-full' onClick={promptCreateEvent}>{t('event.create_button')}</button>
      </div>

      {isVideoAvailable && <div className="m-auto text-center" >
        <YouTube videoId="VTgGOQ_k7F0" options={videoPlayerOptions} onReady={_onVideoPlayerReady} id="video" />
      </div>}
      
      {/* display statistics - title home.statistics_title and in a row number of rideshares, number of kilometers saved and amount of CO2 saved from statistics context */}
      {/* {statisticsLoaded && <section className='home__section mt-20 text-center'>
        <h2 className='home__section-title'>{t('home.statistics_title')}</h2>
        <div className='grid lg:grid-cols-3 gap-16 max-w-5xl mx-auto'>
          <div>
            <h3 className='statistics__value'>{printNumber(statistics.total_rideshares)}</h3>
            <p className='statistics__label'>{t('home.statistics_rideshares')}</p>
          </div>
          <div>
            <h3 className='statistics__value'>{printNumber((statistics.total_distance_saved / 1000).toFixed(0))} <span className="unit">km</span></h3>
            <p className='statistics__label'>{t('home.statistics_kilometers')}</p>
          </div>
          <div>
            <h3 className='statistics__value'>{printNumber(statistics.total_co2_saved.toFixed(0))} <span className="unit">kg</span></h3>
            <p className='statistics__label'>{t('home.statistics_co2')}</p>
          </div>
        </div>
      </section>} */}

      {newsLoaded && filteredNews.length > 0 && (
        <section className='home__section mt-20 home-news'>
          <h2 className='home__section-title'>{t('home.news_title')}</h2>
          {/* <NewsCarousel filteredNews={filteredNews} />
          <NewsCarousel mobile={true} filteredNews={filteredNews} />
          <NewsCarousel mobile={true} offset={2} filteredNews={filteredNews} delay={500} /> */}

          <NewsCarouselContinuous filteredNews={filteredNews} />
          
        </section>
      )}

    </div>
  )
}

export default HomePage
